import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "as-content-page as-match-detail" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { key: 3 }
const _hoisted_6 = { key: 6 }
const _hoisted_7 = { key: 7 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgSprite = _resolveComponent("SvgSprite")!
  const _component_TabsIcon = _resolveComponent("TabsIcon")!
  const _component_IframeChat = _resolveComponent("IframeChat")!
  const _component_StatisticsList = _resolveComponent("StatisticsList")!
  const _component_H2hListSkeleton = _resolveComponent("H2hListSkeleton")!
  const _component_DetailPointList = _resolveComponent("DetailPointList")!
  const _component_BracketTabList = _resolveComponent("BracketTabList")!
  const _component_H2hList = _resolveComponent("H2hList")!
  const _component_MatchOther = _resolveComponent("MatchOther")!
  const _component_NextMatchList = _resolveComponent("NextMatchList")!
  const _component_OddTab = _resolveComponent("OddTab")!
  const _component_Information = _resolveComponent("Information")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SvgSprite),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_TabsIcon, {
        tabs: _ctx.tabs,
        activeTab: _ctx.activeTab,
        isMin: _ctx.isChatTyping,
        onChange: _ctx.changeTab
      }, null, 8, ["tabs", "activeTab", "isMin", "onChange"]),
      _createElementVNode("div", {
        id: "as-match-detail-content",
        class: _normalizeClass(["as-match-detail-content", {
        'as-hide-content': _ctx.isHideContent,
      }]),
        style: _normalizeStyle({
        height: `${_ctx.heightContent}px`,
      })
      }, [
        _withDirectives(_createElementVNode("div", null, [
          _createVNode(_component_IframeChat)
        ], 512), [
          [_vShow, _ctx.activeTab === 'chat']
        ]),
        (_ctx.activeTab === 'statistics')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_ctx.tabLoading.statistics)
                ? (_openBlock(), _createBlock(_component_StatisticsList, {
                    key: 0,
                    match: _ctx.match,
                    statistics: _ctx.statistics
                  }, null, 8, ["match", "statistics"]))
                : (_openBlock(), _createBlock(_component_H2hListSkeleton, { key: 1 }))
            ]))
          : (_ctx.activeTab === 'overview')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_ctx.tabLoading.overview)
                  ? (_openBlock(), _createBlock(_component_DetailPointList, {
                      key: 0,
                      match: _ctx.match,
                      overviews: _ctx.overviews
                    }, null, 8, ["match", "overviews"]))
                  : (_openBlock(), _createBlock(_component_H2hListSkeleton, { key: 1 }))
              ]))
            : (_ctx.activeTab === 'bracket')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_ctx.tabLoading.bracket)
                    ? (_openBlock(), _createBlock(_component_BracketTabList, {
                        key: 0,
                        match: _ctx.match,
                        tournament: _ctx.tournament
                      }, null, 8, ["match", "tournament"]))
                    : (_openBlock(), _createBlock(_component_H2hListSkeleton, { key: 1 }))
                ]))
              : (_ctx.activeTab === 'h2h')
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (_ctx.tabLoading.h2h || _ctx.tabLoading.next_match || _ctx.isObjectNotEmpty(_ctx.h2h))
                      ? (_openBlock(), _createBlock(_component_H2hList, {
                          key: 0,
                          match: _ctx.match,
                          h2h: _ctx.h2h
                        }, null, 8, ["match", "h2h"]))
                      : (_openBlock(), _createBlock(_component_H2hListSkeleton, { key: 1 }))
                  ]))
                : (_ctx.activeTab === 'match_other')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 4,
                      class: _normalizeClass(`as-parent-h2h as-parent-h2h__item-h-auto as-parent-h2h-${_ctx.siteName}`)
                    }, [
                      (_ctx.tabLoading.match_other)
                        ? (_openBlock(), _createBlock(_component_MatchOther, {
                            key: 0,
                            matchLiveData: _ctx.matchOtherData,
                            matchId: _ctx.matchId,
                            mode: "match-other"
                          }, null, 8, ["matchLiveData", "matchId"]))
                        : (_openBlock(), _createBlock(_component_H2hListSkeleton, { key: 1 }))
                    ], 2))
                  : (_ctx.activeTab === 'next_match')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 5,
                        class: _normalizeClass(`as-parent-h2h as-parent-h2h__item-h-auto as-parent-h2h-${_ctx.siteName}`)
                      }, [
                        (_ctx.tabLoading.h2h || _ctx.tabLoading.next_match || _ctx.isObjectNotEmpty(_ctx.h2h))
                          ? (_openBlock(), _createBlock(_component_NextMatchList, {
                              key: 0,
                              match: _ctx.match,
                              h2h: _ctx.h2h
                            }, null, 8, ["match", "h2h"]))
                          : (_openBlock(), _createBlock(_component_H2hListSkeleton, { key: 1 }))
                      ], 2))
                    : (_ctx.activeTab === 'odd')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createVNode(_component_OddTab, {
                            sportType: _ctx.sportType,
                            odd: _ctx.odd,
                            oddOld: _ctx.oddOld
                          }, null, 8, ["sportType", "odd", "oddOld"])
                        ]))
                      : (_ctx.activeTab === 'information')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createVNode(_component_Information, { match: _ctx.match }, null, 8, ["match"])
                          ]))
                        : _createCommentVNode("", true)
      ], 6)
    ])
  ], 64))
}